import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from '../../../core/data/redux/store';
import { createEarning, deleteEarning, fetchEarnings, updateEarning } from '../../../core/data/redux/payroll/payrollComponent/earning/earningActions';
import { Drawer, message, Select } from 'antd';
import DeleteModal1 from '../../../core/modals/deleteModal1';


const EarningModal: React.FC<any> = ({ handleCancel, isModalVisible, modalType, selectedRowData, earningData, setEarningData, setTableKey, setIsDeleteModalVisible, isDeleteModalVisible }) => {
    const dispatch = useDispatch<AppDispatch>();
    const { user } = useSelector((state: any) => state.auth);
    const { earnings, loading } = useSelector((state: any) => state.payroll.earning);
    const [calculationType, setCalculationType] = useState('percentage');
    const [formulaEarnings, setFormulaEarnings] = useState<string[]>([]);
    const [errors, setErrors] = useState({
        Name: '',
        CalculatedUpon: '',
        UnitOfCalculation: '',
        Description: '',
        Percent: '',
        Amount: '',
    });
    const resetForm = () => {
        setEarningData({
            Name: '',
            CalculatedUpon: '',
            Percent: '',
            UnitOfCalculation: '',
            Description: '',
            Amount: '',
        });
        setFormulaEarnings([]);
        setErrors({
            Name: '',
            CalculatedUpon: '',
            UnitOfCalculation: '',
            Description: '',
            Percent: '',
            Amount: '',
        });
    };

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement> | any, field: string) => {
        const value = e.target ? e.target.value : e.value;
        setEarningData({
            ...earningData,
            [field]: value,
        });
        setErrors((prevErrors: any) => ({
            ...prevErrors,
            [field]: '',
        }));
    };

    const [isPercentage, setIsPercentage] = useState(false);
    const [unit, setUnit] = useState('');

    const handleUnitSwitch = () => {
        setIsPercentage(!isPercentage);
    };

    const validateForm = () => {
        let formIsValid = true;
        let newErrors = { ...errors };

        if (!earningData.Name) {
            formIsValid = false;
            newErrors.Name = 'Earning name is required.';
        }
        if (calculationType === 'percentage' && !earningData.CalculatedUpon) {
            formIsValid = false;
            newErrors.CalculatedUpon = 'Calculated Upon must be Required.';
        }
        if (isPercentage && !earningData.UnitOfCalculation) {
            formIsValid = false;
            newErrors.UnitOfCalculation = 'Unit of calculation is required when Percentage is selected.';
        }
        if (calculationType !== 'percentage' && !earningData.Amount) {
            formIsValid = false;
            newErrors.Amount = 'Amount must be Required.';
        }
        if (calculationType === 'percentage') {
            if (
                earningData.Percent === '' ||
                earningData.Percent === null ||
                earningData.Percent === undefined
            ) {
                formIsValid = false;
                newErrors.Percent = 'Percentage is required.';
            } else {
                const percentValue = Number(earningData.Percent);
                if (isNaN(percentValue) || percentValue < 0 || percentValue > 100) {
                    formIsValid = false;
                    newErrors.Percent = 'Percentage must be between 0 and 100.';
                }
            }
        }
        setErrors(newErrors);
        return formIsValid;
    };

    const isEmpty = (v: any) => v === '' || v === null || v === undefined;

    React.useEffect(() => {
        if (!isModalVisible) return;

        const percentEmpty = isEmpty(earningData?.Percent);
        const calcUponEmpty = isEmpty(earningData?.CalculatedUpon);

        if (percentEmpty && calcUponEmpty) {
            setCalculationType('amount');
        } else {
            setCalculationType('percentage');
        }
    }, [isModalVisible, earningData?.Percent, earningData?.CalculatedUpon]);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!validateForm()) {
            return;
        }
        const updatedFormData = {
            ...earningData,
            // Formula: earningData.Formula || formulaEarnings.join(' + '),
            Percent: earningData.Percent === '' ? null : earningData.Percent,
            Amount: earningData.Amount === '' ? null : earningData.Amount,
            CreatedBy: modalType === 'create' ? user.UserId : undefined,
            ModifiedBy: modalType === 'edit' ? user.UserId : undefined,
        };
        try {
            let result;
            if (modalType === 'create') {
                result = await dispatch(createEarning(updatedFormData)).unwrap();

            } else if (modalType === 'edit') {
                if (selectedRowData) {
                    result = await dispatch(updateEarning({ id: selectedRowData.Id, ...updatedFormData })).unwrap();
                }
            }
            if (result) {
                message.success(result.message);
                await dispatch(fetchEarnings());
                setTableKey((prevKey: any) => prevKey + 1);
                resetForm();
            } else {
                alert(result?.payload.error);
            }
            handleCancel();
        } catch (error: any) {
            const errorMessage = error?.error || 'An error occurred';
            message.error(errorMessage);
        }
    };
    const handleDeleteEarning = async (id: number) => {
        try {
            const result = await dispatch(deleteEarning(id));
            if (result.meta.requestStatus === 'fulfilled') {
                message.success(result.payload.message);
                await dispatch(fetchEarnings());
                setTableKey((prevKey: any) => prevKey + 1);
                setIsDeleteModalVisible(false);
            } else {
                message.warning(result.payload.error);
            }
        } catch (error) {
            message.error('Something went wrong');
        }
    };

    return (
        <>
            <Drawer
                title={modalType === "edit" ? "Edit Earning" : "Add Earning"}
                placement="right"
                width={600}
                onClose={() => {
                    handleCancel();
                    resetForm();
                }}
                visible={isModalVisible}
                style={{ marginTop: 50, paddingBottom: 50 }}
            >
                <form onSubmit={handleSubmit}>
                    <div className="modal-body pb-0">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="mb-3">
                                    <label className="form-label">
                                        Earning Name <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="Name"
                                        value={earningData.Name}
                                        onChange={(e) => handleInputChange(e, 'Name')}
                                    />
                                    {errors.Name && <div className="text-danger">{errors.Name}</div>}
                                </div>
                            </div>
                        </div>
                        {/* Radio Buttons for Calculation Type (Percentage or Amount) */}
                        <div className="row mb-2">
                            <div className="col-md-12">
                                <div className="form-check form-check-inline">
                                    <input
                                        type="radio"
                                        id="percentageRadio"
                                        name="calculationType"
                                        value="percentage"
                                        checked={calculationType === 'percentage'}
                                        onChange={() => {
                                            setCalculationType('percentage');
                                            setEarningData((prev: any) => ({
                                                ...prev,
                                                Amount: '',
                                            }));
                                        }}

                                        className="form-check-input"
                                    />
                                    <label className="form-check-label" htmlFor="percentageRadio">
                                        Percentage
                                    </label>
                                </div>
                                <div className="form-check form-check-inline">
                                    <input
                                        type="radio"
                                        id="amountRadio"
                                        name="calculationType"
                                        value="amount"
                                        checked={calculationType === 'amount'}
                                        onChange={() => {
                                            setCalculationType('amount');
                                            setEarningData((prev: any) => ({
                                                ...prev,
                                                Percent: '',
                                                CalculatedUpon: '',
                                            }));
                                        }}
                                        className="form-check-input"
                                    />
                                    <label className="form-check-label" htmlFor="amountRadio">
                                        Absolute
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <label className="form-label">
                                    Calculated Upon <span className="text-danger">*</span>
                                </label>
                                <div className="mb-3">

                                    <select
                                        className="form-control"
                                        value={earningData.CalculatedUpon}
                                        onChange={(e) => handleInputChange(e, 'CalculatedUpon')}
                                        disabled={calculationType === 'amount'}
                                    >
                                        <option value="">select</option>
                                        {earnings?.map((ear: any) => (
                                            <option key={ear.Id} value={ear.Name}>
                                                {ear.Name}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.CalculatedUpon && <div className="text-danger">{errors.CalculatedUpon}</div>}
                                </div>
                            </div>
                            {calculationType === 'percentage' ? (
                                <div className="col-md-6">
                                    <label className="form-label">
                                        Percentage <span className="text-danger">*</span>
                                    </label>
                                    <div className="mb-3">
                                        <input
                                            type="number"
                                            className="form-control"
                                            name="Percent"
                                            value={earningData.Percent}
                                            onChange={(e) => handleInputChange(e, 'Percent')}
                                            step="0.01"
                                            placeholder="e.g., 40"
                                        />
                                        {errors.Percent && <div className="text-danger">{errors.Percent}</div>}
                                    </div>
                                </div>
                            ) : (
                                <div className="col-md-6">
                                    <label className="form-label">
                                        Amount <span className="text-danger">*</span>
                                    </label>
                                    <div className="mb-3">
                                        <input
                                            type="number"
                                            className="form-control"
                                            name="Amount"
                                            value={earningData.Amount}
                                            onChange={(e) => handleInputChange(e, 'Amount')}
                                            step="0.01"
                                            placeholder="e.g., 1000"
                                        />
                                        {errors.Amount && <div className="text-danger">{errors.Amount}</div>}
                                    </div>
                                </div>
                            )}
                        </div>
                        {/* {earningData.Formula && (
                            <div className="my-2">
                                <strong>Formula Preview:</strong> {earningData.Formula}
                            </div>
                        )}
                        <Select
                            mode="multiple"
                            placeholder="Select earnings for formula"
                            value={formulaEarnings}
                            onChange={(values) => {
                                setFormulaEarnings(values);
                                setEarningData({ ...earningData, Formula: values.join(' + ') });
                            }}
                            tagRender={(props) => {
                                const { label, closable, onClose } = props;
                                return (
                                    <span
                                        style={{
                                            backgroundColor: '#ffcccc',
                                            color: '#b00000',
                                            padding: '2px 6px',
                                            borderRadius: '4px',
                                            marginRight: '4px',
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            height: '28px',         // Matches Antd default tag height
                                            lineHeight: '24px'
                                        }}
                                    >
                                        {label}
                                        {closable && (
                                            <span
                                                style={{ marginLeft: '4px', cursor: 'pointer', fontWeight: 'bold' }}
                                                onClick={onClose}
                                            >
                                                ×
                                            </span>
                                        )}
                                    </span>
                                );
                            }}
                            style={{ width: '100%' }}
                        >
                            {earnings?.map((ear: any) => (
                                <Select.Option key={ear.Id} value={ear.Name}>
                                    {ear.Name}
                                </Select.Option>
                            ))}
                        </Select> */}

                        {/* <div className="row mb-2">
                            <div className="col-md-12">
                                <label className="form-label">
                                    Unit of Calculation <span className="text-danger">*</span>
                                </label>
                                <div className="form-check form-switch mb-2">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        role="switch"
                                        id="unitOfCalculationSwitch"
                                        checked={isPercentage}
                                        onChange={handleUnitSwitch}
                                    />
                                </div>
                            </div>
                        </div> */}

                        {/* Conditionally render Unit input field if "Unit of Calculation" is checked */}
                        {isPercentage && (
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="mb-3 mt-2">
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="Unit"
                                            value={earningData.UnitOfCalculation}
                                            onChange={(e) => handleInputChange(e, 'UnitOfCalculation')}
                                            placeholder="e.g., per month, per year"
                                        />
                                        {errors.UnitOfCalculation && (
                                            <div className="text-danger">{errors.UnitOfCalculation}</div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}

                        <div className="col-md-12">
                            <label className="form-label">
                                Description
                            </label>
                            <div className="mb-3">
                                <input
                                    type="text"
                                    className="form-control"
                                    name="Description"
                                    value={earningData.Description}
                                    onChange={(e) => handleInputChange(e, 'Description')}
                                    placeholder="Description"
                                />
                                {errors.Description && <div className="text-danger">{errors.Description}</div>}
                            </div>
                        </div>
                    </div>

                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-white border me-2"
                            onClick={() => {
                                resetForm()
                                handleCancel()
                            }}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="btn btn-primary" disabled={loading}
                            data-bs-dismiss={loading ? "" : "Modal"}
                        >
                            {loading && <span className="spinner-border spinner-border-sm me-2" />}
                            {modalType === "edit" ? "Update Earning" : "Add Earning"}
                        </button>
                    </div>
                </form>

            </Drawer >
            <DeleteModal1
                isVisible={isDeleteModalVisible}
                onClose={() => setIsDeleteModalVisible(false)}
                onConfirm={() => selectedRowData?.Id && handleDeleteEarning(selectedRowData.Id)}
            />
        </>

    )
}

export default EarningModal